import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77d33629"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade show",
  id: "kt_modal_select_agendamento",
  "aria-modal": "true",
  role: "dialog",
  ref: "newTargetModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-flex align-items-start justify-content-between pb-3" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center\" data-v-77d33629><div class=\"mx-4 symbol symbol-circle\" data-v-77d33629><span class=\"symbol-label btn-icon-white bg-primary\" data-v-77d33629><i class=\"fas fa-calendar-day text-white pa-5 fs-1\" data-v-77d33629></i></span></div><h3 class=\"card-title d-flex align-items-start flex-column\" data-v-77d33629><p class=\"card-label fw-bolder fs-4 mb-1\" data-v-77d33629>Programar Serviço</p><p class=\"text-muted mt-1 fs-7 fw-light\" data-v-77d33629>Agende um serviço</p></h3></div>", 1)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","right":"25px"} }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_7 = { class: "me-10" }
const _hoisted_8 = { class: "card shadow-sm" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "d-flex justify-content-end mb-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, null, -1))
const _hoisted_12 = {
  class: "d-flex justify-content-center mb-8",
  style: {"position":"relative"}
}
const _hoisted_13 = {
  key: 0,
  style: {"position":"absolute","right":"0px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "32",
  rx: "2",
  ry: "2",
  width: "140",
  height: "42"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "26",
  y: "11",
  rx: "2",
  ry: "2",
  width: "136",
  height: "11"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "89",
  rx: "2",
  ry: "2",
  width: "560",
  height: "1"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "23",
  r: "4"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "16",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "46",
  r: "4"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "40",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "70",
  r: "4"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "65",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "413",
  y: "29",
  rx: "2",
  ry: "2",
  width: "136",
  height: "28"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "23",
  y: "131",
  rx: "2",
  ry: "2",
  width: "140",
  height: "42"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "25",
  y: "110",
  rx: "2",
  ry: "2",
  width: "136",
  height: "11"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "9",
  y: "188",
  rx: "2",
  ry: "2",
  width: "560",
  height: "1"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "227",
  cy: "122",
  r: "4"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "241",
  y: "115",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "227",
  cy: "145",
  r: "4"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "241",
  y: "139",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "227",
  cy: "169",
  r: "4"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "241",
  y: "164",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "412",
  y: "128",
  rx: "2",
  ry: "2",
  width: "136",
  height: "28"
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "228",
  rx: "2",
  ry: "2",
  width: "140",
  height: "42"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "26",
  y: "207",
  rx: "2",
  ry: "2",
  width: "136",
  height: "11"
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "12",
  y: "285",
  rx: "2",
  ry: "2",
  width: "560",
  height: "1"
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "219",
  r: "4"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "212",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "242",
  r: "4"
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "236",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "266",
  r: "4"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "261",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "413",
  y: "225",
  rx: "2",
  ry: "2",
  width: "136",
  height: "28"
}, null, -1))
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = { class: "placa-container w-200px" }
const _hoisted_47 = { class: "placa-cliente fs-4 text-center" }
const _hoisted_48 = {
  key: 0,
  class: "placa-agendamento w-200px",
  style: {"background":"url('./img/placabg.5218d926.png') no-repeat no-repeat center center","background-size":"contain"}
}
const _hoisted_49 = { class: "placa-text" }
const _hoisted_50 = {
  key: 1,
  class: "chassi-agendamento w-200px",
  style: {"background":"url('./bg/chassibg.jpeg') no-repeat no-repeat center center","background-size":"contain"}
}
const _hoisted_51 = { class: "fs-5 text-truncate ps-2 pe-2" }
const _hoisted_52 = { class: "fs-6 text-center" }
const _hoisted_53 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "d-flex flex-column justify-content-around" }
const _hoisted_57 = { class: "d-flex justify-content-center" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "svg-icon svg-icon-2 cor_btn_1" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "d-flex justify-content-end" }
const _hoisted_62 = { class: "svg-icon svg-icon-2 cor_btn_1" }
const _hoisted_63 = {
  class: "modal fade show",
  id: "kt_modal_select_agendamento_realizados",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_64 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = { class: "modal-header d-flex align-items-start justify-content-between pb-3" }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center\" data-v-77d33629><div class=\"mx-4 symbol symbol-circle\" data-v-77d33629><span class=\"symbol-label btn-icon-white bg-primary\" data-v-77d33629><i class=\"fas fa-calendar-day text-white pa-5 fs-1\" data-v-77d33629></i></span></div><h3 class=\"card-title d-flex align-items-start flex-column\" data-v-77d33629><p class=\"card-label fw-bolder fs-4 mb-1\" data-v-77d33629>Serviços já agendados</p><p class=\"text-muted mt-1 fs-7 fw-light\" data-v-77d33629>Visualize os serviços já agendados</p></h3></div>", 1)
const _hoisted_68 = { style: {"position":"absolute","right":"25px"} }
const _hoisted_69 = { class: "card shadow-sm" }
const _hoisted_70 = { class: "card-body" }
const _hoisted_71 = { class: "d-flex justify-content-center mb-8" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "32",
  rx: "2",
  ry: "2",
  width: "140",
  height: "42"
}, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "26",
  y: "11",
  rx: "2",
  ry: "2",
  width: "136",
  height: "11"
}, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "89",
  rx: "2",
  ry: "2",
  width: "560",
  height: "1"
}, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "23",
  r: "4"
}, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "16",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "46",
  r: "4"
}, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "40",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "70",
  r: "4"
}, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "65",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "413",
  y: "29",
  rx: "2",
  ry: "2",
  width: "136",
  height: "28"
}, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "23",
  y: "131",
  rx: "2",
  ry: "2",
  width: "140",
  height: "42"
}, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "25",
  y: "110",
  rx: "2",
  ry: "2",
  width: "136",
  height: "11"
}, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "9",
  y: "188",
  rx: "2",
  ry: "2",
  width: "560",
  height: "1"
}, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "227",
  cy: "122",
  r: "4"
}, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "241",
  y: "115",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "227",
  cy: "145",
  r: "4"
}, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "241",
  y: "139",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "227",
  cy: "169",
  r: "4"
}, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "241",
  y: "164",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "412",
  y: "128",
  rx: "2",
  ry: "2",
  width: "136",
  height: "28"
}, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "228",
  rx: "2",
  ry: "2",
  width: "140",
  height: "42"
}, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "26",
  y: "207",
  rx: "2",
  ry: "2",
  width: "136",
  height: "11"
}, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "12",
  y: "285",
  rx: "2",
  ry: "2",
  width: "560",
  height: "1"
}, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "219",
  r: "4"
}, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "212",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "242",
  r: "4"
}, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "236",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "228",
  cy: "266",
  r: "4"
}, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "242",
  y: "261",
  rx: "2",
  ry: "2",
  width: "136",
  height: "10"
}, null, -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "413",
  y: "225",
  rx: "2",
  ry: "2",
  width: "136",
  height: "28"
}, null, -1))
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { class: "d-flex" }
const _hoisted_104 = { class: "placa-container w-100px" }
const _hoisted_105 = { class: "placa-cliente fs-4 text-center" }
const _hoisted_106 = {
  key: 0,
  class: "placa-agendamento w-100px my-n3",
  style: {"background":"url('./img/placabg.5218d926.png') no-repeat no-repeat center center","background-size":"contain"}
}
const _hoisted_107 = {
  class: "placa-text",
  style: {"font-size":"16px"}
}
const _hoisted_108 = {
  key: 1,
  class: "chassi-agendamento w-100px",
  style: {"background":"url('./bg/chassibg.jpeg') no-repeat no-repeat center center","background-size":"contain"}
}
const _hoisted_109 = { class: "fs-5 text-truncate ps-2 pe-2" }
const _hoisted_110 = {
  class: "fs-6 text-center text-truncate w-100px",
  style: {"direction":"rtl"}
}
const _hoisted_111 = { class: "d-flex flex-column flex-grow-1 px-4" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = {
  key: 0,
  class: "d-flex flex-column mt-2 flex-grow-1"
}
const _hoisted_115 = {
  class: "d-flex px-2 flex-wrap",
  style: {"max-width":"350px"}
}
const _hoisted_116 = ["onClick"]
const _hoisted_117 = {
  class: "event mx-2",
  style: {"background-color":"white"}
}
const _hoisted_118 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = { class: "svg-icon svg-icon-2 cor_btn_1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiltroDataModal = _resolveComponent("FiltroDataModal")!
  const _component_ContentLoader = _resolveComponent("ContentLoader")!
  const _component_StatusChecklist = _resolveComponent("StatusChecklist")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_EditarServicoModal = _resolveComponent("EditarServicoModal")!
  const _component_AdicionarServicoModal = _resolveComponent("AdicionarServicoModal")!
  const _component_AdicionarServicoPassanteModal = _resolveComponent("AdicionarServicoPassanteModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FiltroDataModal, {
                  id: "filter-modal-agendamento",
                  onFiltrarModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtraDados($event.data)))
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateSchedule && _ctx.handleUpdateSchedule(...args))),
                  class: "btn btn-flex background_btn_1_opct text-white btn-sm"
                }, [
                  _hoisted_11,
                  _createTextVNode(" Atualizar Agendamento ")
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.dataFiltrada), 1),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_ctx.agendamentosAgendados.length > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm background_btn_1_opct btn-flex btn-outline border_btn_1 cor_btn_1",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModalServicosAgendados()))
                          }, " Exibir serviços já agendados "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_ContentLoader, {
                    key: 0,
                    viewBox: "0 0 590 280",
                    animate: true,
                    primaryColor: "#f3f3f3",
                    secondaryColor: "#ecebeb"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agendamentos, (agendamento, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "hr-agendamento d-flex flex-column pb-4 mb-6",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("p", _hoisted_47, _toDisplayString(agendamento.clienteTratado), 1),
                            (agendamento.placa)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                  _createElementVNode("p", _hoisted_49, _toDisplayString(agendamento.placa), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.cutChassi(agendamento.chassi,6,'...')), 1)
                                ])),
                            _createElementVNode("p", _hoisted_52, _toDisplayString(agendamento.chassi), 1)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", null, [
                              _createElementVNode("ul", null, [
                                (agendamento.osaberta)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_54, " OS Aberta: " + _toDisplayString(agendamento.osaberta), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", null, " Horário Recepção: " + _toDisplayString(agendamento.data), 1),
                                _createElementVNode("li", null, " Modelo: " + _toDisplayString(agendamento.modelo), 1),
                                (agendamento.consultorTratado)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_55, " Consultor: " + _toDisplayString(agendamento.consultorTratado), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              (agendamento.dadosChecklist)
                                ? (_openBlock(), _createBlock(_component_StatusChecklist, {
                                    key: 0,
                                    statusCor: agendamento.dadosChecklist.setorCor,
                                    setor: agendamento.dadosChecklist?.setor
                                  }, null, 8, ["statusCor", "setor"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                class: "btn btn-flex background_btn_1_opct text-white btn-sm",
                                onClick: ($event: any) => (_ctx.newTask(agendamento))
                              }, [
                                _createElementVNode("span", _hoisted_59, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                                ]),
                                _createTextVNode(" Programar serviço ")
                              ], 8, _hoisted_58)
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.agendamentos.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createVNode(_component_el_empty, { description: "Nenhum agendamento foi econtrado" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-flex background_btn_1_opct text-white btn-sm",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModalSericoPassante()))
                        }, [
                          _createElementVNode("span", _hoisted_62, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                          ]),
                          _createTextVNode(" Programar serviço (Passante) ")
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "aria-label": "Close",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModalServicosAgendados()))
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.dataFiltrada), 1)
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_ContentLoader, {
                    key: 0,
                    viewBox: "0 0 590 280",
                    animate: true,
                    primaryColor: "#f3f3f3",
                    secondaryColor: "#ecebeb"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72,
                      _hoisted_73,
                      _hoisted_74,
                      _hoisted_75,
                      _hoisted_76,
                      _hoisted_77,
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _hoisted_81,
                      _hoisted_82,
                      _hoisted_83,
                      _hoisted_84,
                      _hoisted_85,
                      _hoisted_86,
                      _hoisted_87,
                      _hoisted_88,
                      _hoisted_89,
                      _hoisted_90,
                      _hoisted_91,
                      _hoisted_92,
                      _hoisted_93,
                      _hoisted_94,
                      _hoisted_95,
                      _hoisted_96,
                      _hoisted_97,
                      _hoisted_98,
                      _hoisted_99,
                      _hoisted_100,
                      _hoisted_101
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agendamentosAgendados, (agendamento, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "hr-agendamento d-flex flex-column pb-4 mb-6",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("p", _hoisted_105, _toDisplayString(agendamento.clienteTratado), 1),
                            (agendamento.placa)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                  _createElementVNode("p", _hoisted_107, _toDisplayString(agendamento.placa), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.cutChassi(agendamento.chassi,6,'...')), 1)
                                ])),
                            _createElementVNode("p", _hoisted_110, _toDisplayString(agendamento.chassi), 1)
                          ]),
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("div", null, [
                              _createElementVNode("ul", null, [
                                (agendamento.osaberta)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_112, " OS Aberta: " + _toDisplayString(agendamento.osaberta), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", null, " Horário Recepção: " + _toDisplayString(agendamento.data), 1),
                                _createElementVNode("li", null, " Modelo: " + _toDisplayString(agendamento.modelo), 1),
                                (agendamento.consultorTratado)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_113, " Consultor: " + _toDisplayString(agendamento.consultorTratado), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (agendamento.servicosAgendadosTratado.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                  _createElementVNode("div", _hoisted_115, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agendamento.servicosAgendadosTratado, (servicosAgendado, key) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: key,
                                        onClick: ($event: any) => (_ctx.openEditVisualizarServicoModal(servicosAgendado))
                                      }, [
                                        _createElementVNode("div", _hoisted_117, [
                                          _createElementVNode("div", {
                                            class: "event-header",
                                            style: _normalizeStyle(`color: ${servicosAgendado.extendedProps.headerTextColor}; background-color: ${servicosAgendado.extendedProps.bgColor}`)
                                          }, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(`event-title`),
                                              style: _normalizeStyle(`color: ${servicosAgendado.extendedProps.headerTextColor}`)
                                            }, _toDisplayString(servicosAgendado.title) + " - " + _toDisplayString(servicosAgendado.extendedProps.duration) + " min ", 5)
                                          ], 4)
                                        ])
                                      ], 8, _hoisted_116))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("button", {
                              class: "btn btn-flex background_btn_1_opct text-white btn-sm text-nowrap",
                              onClick: ($event: any) => (_ctx.newTask(agendamento))
                            }, [
                              _createElementVNode("span", _hoisted_120, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                              ]),
                              _createTextVNode(" Programar serviço ")
                            ], 8, _hoisted_119)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_EditarServicoModal, {
      id: "2",
      showEntregaControl: true,
      editable: true,
      eventInfo: _ctx.eventInfo,
      onSuccess: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emiteSuccess()))
    }, null, 8, ["eventInfo"]),
    _createVNode(_component_AdicionarServicoModal, {
      id: "agendamento-modal-servico",
      initialForm: _ctx.initialForm,
      onSuccess: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emiteSuccess()))
    }, null, 8, ["initialForm"]),
    _createVNode(_component_AdicionarServicoPassanteModal, {
      id: "agendamento-modal-passante",
      initialForm: _ctx.initialForm,
      onSuccess: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emiteSuccess()))
    }, null, 8, ["initialForm"])
  ]))
}